import Image from 'app/Components/Shared/Image/image';
import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import { isMobile } from 'react-device-detect';
import Config from '../../../../../Config';
import ChannelsSwiper from '../channelsSwiper/channelsSwiper';

const PackageHeader = (props) => {

    const packageImage = () => {
        let packageImage = props.defaultImage;
        if (isMobile) {
            if (props.selectedPackage.cmsData?.selfCare?.mobileImage) {
                packageImage = props.selectedPackage.cmsData?.selfCare?.mobileImage;
            }
        }
        else {
            if (props.selectedPackage.cmsData?.selfCare?.desktopImage) {
                packageImage = props.selectedPackage.cmsData?.selfCare?.desktopImage;
            }
        }
        return (<div className='package-image-wrapper'><Image className='package-image' src={Config.epiBaseUrl + packageImage} alt='package image' /></div>)
    }

    return (
        <div className='premium-packages-catalog-header'>
            {packageImage()}
            {props.selectedPackage?.cmsData?.channels?.length > 0 &&
                <div className='channels'>
                    <h5>הערוצים הכלולים בחבילה</h5>
                    <ChannelsSwiper channels={props.selectedPackage?.cmsData?.channels} hideNavigationBtn={true} />
                </div>
            }
            <p className='description'>{props.selectedPackage?.cmsData?.selfCare.description}</p>
        </div>
    );
};



export default PackageHeader;
